import { i18n } from '../i18n/i18n';
import * as Role from '../utils/user-roles';

function loadView(view) {
  return () => import(`@/views/${view}.vue`);
}

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: loadView('Login'),
  },
  {
    path: '/voter',
    name: 'voter',
    component: loadView('Voter/Voter'),
    meta: {},
    children: [
      {
        path: 'projector',
        name: 'projector',
        component: loadView('Voter/Projector'),
        meta: {},
      },
      {
        path: 'select',
        name: 'select',
        component: loadView('Voter/SelectionScreen'),
        meta: {
          roles: [Role.ROLE_VOTE_VIEWER],
        },
      },
    ],
  },
  {
    path: '/vote',
    component: loadView('Vote/Vote'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'hello',
        name: 'hello',
        component: loadView('Vote/Hello'),
        meta: {
          roles: [Role.ROLE_VOTE_VIEWER],
        },
      },
      {
        path: 'active',
        name: 'vote-active',
        component: loadView('Vote/VoteActive'),
        meta: {
          roles: [Role.ROLE_VOTE_VIEWER],
          header: i18n.t('CURRENT_SESSION'),
        },
      },
    ],
  },
  {
    path: '/profile',
    name: 'profile',
    component: loadView('Profile'),
    meta: {
      roles: [...Object.values(Role)],
      header: i18n.t('MY_PROFILE'),
    },
  },
  {
    path: '/users',
    component: loadView('Users/Users'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:page?',
        name: 'users-list',
        component: loadView('Users/UsersList'),
        meta: {
          roles: [Role.ROLE_USER_MANAGER],
          header: i18n.t('USERS_LIST'),
        },
      },
      {
        path: 'create',
        name: 'users-create',
        component: loadView('Users/UsersManagement'),
        meta: {
          roles: [Role.ROLE_USER_MANAGER],
          header: i18n.t('CREATE_USER'),
        },
      },
      {
        path: 'edit/:id',
        name: 'users-edit',
        component: loadView('Users/UsersManagement'),
        meta: {
          roles: [Role.ROLE_USER_MANAGER],
          header: i18n.t('EDIT_USER'),
        },
      },
      {
        path: 'notifications-send',
        name: 'users-notifications-send',
        component: loadView('Users/UsersNotificationsManagement'),
        meta: {
          roles: [Role.ROLE_NOTIFICATION_MANAGER],
          header: i18n.t('NOTIFICATIONS_SEND'),
        },
      },
      {
        path: 'notifications-list/:page?',
        name: 'users-notifications-list',
        component: loadView('Users/UsersNotificationsList'),
        meta: {
          roles: [Role.ROLE_NOTIFICATION_MANAGER],
          header: i18n.t('NOTIFICATIONS_LIST'),
        },
      },
      {
        path: 'notifications/:id',
        name: 'users-notifications-details',
        component: loadView('Users/UsersNotificationsDetails'),
        meta: {
          roles: [Role.ROLE_NOTIFICATION_MANAGER],
          header: i18n.t('NOTIFICATIONS_DETAILS'),
        },
      },
    ],
  },
  {
    path: '/groups',
    component: loadView('Groups/Groups'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:page?',
        name: 'groups-list',
        component: loadView('Groups/GroupsList'),
        meta: {
          roles: [Role.ROLE_GROUP_MANAGER],
          header: i18n.t('GROUPS_LIST'),
        },
      },
      {
        path: 'create',
        name: 'groups-create',
        component: loadView('Groups/GroupsManagement'),
        meta: {
          roles: [Role.ROLE_GROUP_MANAGER],
          header: i18n.t('CREATE_GROUP'),
        },
      },
      {
        path: 'edit/:id',
        name: 'groups-edit',
        component: loadView('Groups/GroupsManagement'),
        meta: {
          roles: [Role.ROLE_GROUP_MANAGER],
          header: i18n.t('EDIT_GROUP'),
        },
      },
    ],
  },
  {
    path: '/documents',
    component: loadView('Documents/Documents'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:page?',
        name: 'documents-list',
        component: loadView('Documents/DocumentsList'),
        meta: {
          roles: [Role.ROLE_DOCUMENT_MANAGER, Role.ROLE_DOCUMENT_VIEWER],
          header: i18n.t('DOCUMENTS_LIST'),
        },
      },
      {
        path: 'create',
        name: 'documents-create',
        component: loadView('Documents/DocumentsManagement'),
        meta: {
          roles: [Role.ROLE_DOCUMENT_MANAGER],
          header: i18n.t('CREATE_DOCUMENT'),
        },
      },
      {
        path: 'edit/:id',
        name: 'documents-edit',
        component: loadView('Documents/DocumentsManagement'),
        meta: {
          roles: [Role.ROLE_DOCUMENT_MANAGER],
          header: i18n.t('EDIT_DOCUMENT'),
        },
      },
      {
        path: ':id',
        name: 'documents-details',
        component: loadView('Documents/DocumentsManagement'),
        meta: {
          roles: [Role.ROLE_DOCUMENT_MANAGER, Role.ROLE_DOCUMENT_VIEWER],
          header: i18n.t('DOCUMENT_DETAILS'),
          readonlyMode: true,
        },
      },
    ],
  },
  {
    path: '/streams',
    component: loadView('Streams/Streams'),
    children: [
      {
        path: 'changelog',
        name: 'changelog',
        component: loadView('Streams/StreamChangelog'),
        meta: {
          roles: [Role.ROLE_STREAM_MANAGER],
          data: {
            title: i18n.t('CHANGELOG'),
          },
        },
      },
      {
        path: 'control',
        name: 'streams-control',
        component: loadView('Streams/StreamsControl'),
        meta: {
          roles: [Role.ROLE_STREAM_MANAGER],
          header: i18n.t('CONTROL'),
        },
      },
      {
        path: 'config',
        name: 'streams-settings',
        component: loadView('Streams/StreamsSettings'),
        meta: {
          roles: [],
          header: i18n.t('SETTINGS'),
        },
      },
    ],
  },
  {
    path: '/vod',
    component: loadView('Vod/Vod'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'browse-videos',
        name: 'vod-browse-videos',
        component: loadView('Vod/VodFiles'),
        meta: {
          roles: [Role.ROLE_VOD_MANAGER],
          header: i18n.t('BROWSE_VIDEOS'),
        },
      },
      {
        path: 'publish-video/:id',
        name: 'vod-publish-video',
        component: loadView('Vod/VodPublish'),
        meta: {
          roles: [Role.ROLE_VOD_MANAGER],
          header: i18n.t('PUBLISH_VIDEO'),
        },
      },
      {
        path: 'edit-publication-video/:id',
        name: 'vod-edit-publication-video',
        component: loadView('Vod/VodPublish'),
        meta: {
          roles: [Role.ROLE_VOD_MANAGER],
          header: i18n.t('EDIT_PUBLICATION'),
          edit: true,
        },
      },
      {
        path: 'edit-video/:id',
        name: 'vod-edit-video',
        component: loadView('Vod/VodEdit'),
        meta: {
          roles: [Role.ROLE_VOD_MANAGER],
          header: i18n.t('VIDEO_EDIT'),
          edit: true,
        },
      },
      {
        path: 'video-publications-list/:page?',
        name: 'vod-video-publications-list',
        component: loadView('Vod/VodPublications'),
        meta: {
          roles: [Role.ROLE_VOD_MANAGER],
          header: i18n.t('VIDEO_PUBLICATIONS_LIST'),
        },
      },
      {
        path: 'video-subtitles-edit/:id',
        name: 'vod-video-subtitles-edit',
        component: loadView('Vod/VodSubtitles'),
        meta: {
          roles: [Role.ROLE_VOD_MANAGER],
          header: i18n.t('VIDEO_SUBTITLES_EDIT'),
        },
      },
    ],
  },
  {
    path: '/sessions',
    component: loadView('Sessions/Sessions'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'print-protocol/:withDetails/:id/:voteTopicId?',
        name: 'print-protocol',
        component: loadView('Sessions/SessionPrintProtocol'),
      },
      {
        path: 'participants/:page?',
        name: 'participants-list',
        component: loadView('Sessions/SessionParticipants'),
        meta: {
          roles: [Role.ROLE_VOTE_MANAGER],
          data: {
            title: i18n.t('USERS'),
            description: i18n.t('SESSION_PARTICIPANTS_ROUTE_DESC'),
            icon: 'people',
          },
        },
      },
      {
        path: 'list/:page?',
        name: 'sessions-list',
        component: loadView('Sessions/SessionsList'),
        meta: {
          roles: [Role.ROLE_VOTE_MANAGER],
          data: {
            title: i18n.t('SESSIONS_LIST'),
            description: i18n.t('SESSIONS_LIST_ROUTE_DESC'),
            icon: 'list',
          },
        },
      },
      {
        path: 'create',
        name: 'sessions-create',
        component: loadView('Sessions/SessionsManagement'),
        meta: {
          roles: [Role.ROLE_VOTE_MANAGER],
          readonlyMode: true,
          data: {
            title: i18n.t('SESSIONS_CREATE'),
            description: i18n.t('SESSION_CREATE_ROUTE_DESC'),
            icon: 'add_box',
          },
        },
      },
      {
        path: ':id',
        name: 'session-details',
        component: loadView('Sessions/SessionDetails'),
        meta: {
          roles: [Role.ROLE_VOTE_MANAGER],
          readonlyMode: true,
          data: {
            title: i18n.t('SESSION_DETAILS'),
            description: i18n.t('SESSION_DETAILS_ROUTE_DESC'),
            icon: 'how_to_vote',
          },
        },
      },
      {
        path: 'edit/:id',
        name: 'session-edit',
        component: loadView('Sessions/SessionsManagement'),
        meta: {
          roles: [Role.ROLE_VOTE_MANAGER],
          data: {
            title: i18n.t('EDIT_SESSION'),
            description: i18n.t('SESSION_EDIT_ROUTE_DESC'),
            icon: 'edit',
          },
        },
      },
    ],
  },
  {
    path: '/settings',
    name: 'settings',
    component: loadView('Settings'),
    meta: {
      roles: [Role.ROLE_SETTINGS_MANAGER],
      header: i18n.t('SETTINGS'),
    },
  },
  {
    path: '/pages',
    name: 'pages',
    component: loadView('Pages/Pages'),
    meta: {
      roles: [Role.ROLE_CMS_MANAGER],
      header: i18n.t('PAGES'),
    },
    children: [
      {
        path: 'list/:page?',
        name: 'pages-list',
        component: loadView('Pages/PagesList'),
        meta: {
          roles: [Role.ROLE_CMS_MANAGER],
          header: i18n.t('PAGES_LIST'),
        },
      },
      {
        path: 'create',
        name: 'pages-create',
        component: loadView('Pages/PageManagement'),
        meta: {
          roles: [Role.ROLE_CMS_MANAGER],
          header: i18n.t('CREATE_PAGE'),
        },
      },
      {
        path: 'menu',
        name: 'pages-menu',
        component: loadView('Pages/MenuList'),
        meta: {
          roles: [Role.ROLE_CMS_MANAGER],
          header: i18n.t('MENU'),
        },
      },
      {
        path: 'menu/create',
        name: 'pages-menu-create',
        component: loadView('Pages/MenuLinkManagement'),
        meta: {
          roles: [Role.ROLE_CMS_MANAGER],
          header: i18n.t('MENU_CREATE'),
        },
      },
      {
        path: 'menu/edit/:id',
        name: 'pages-menu-edit',
        component: loadView('Pages/MenuLinkManagement'),
        meta: {
          roles: [Role.ROLE_CMS_MANAGER],
          header: i18n.t('MENU_EDIT'),
        },
      },
      {
        path: 'edit/:id',
        name: 'pages-edit',
        component: loadView('Pages/PageManagement'),
        meta: {
          roles: [Role.ROLE_CMS_MANAGER],
          header: i18n.t('EDIT_PAGE'),
        },
      },
    ],
  },
  {
    path: '*',
    name: 'not-found',
    component: loadView('PageNotFound'),
  },
];

export { routes };
